import {
  WHATSAPP_GET_LIST,
  WHATSAPP_GET_LIST_SUCCESS,
  WHATSAPP_GET_LIST_ERROR,
  WHATSAPP_UPDATE_ITEM,
  WHATSAPP_UPDATE_SESSION,
  WHATSAPP_DELETE_ITEM,
  WHATSAPP_ADD_ITEM,
  WHATSAPP_RESET_LIST,
} from '../contants';

export const getWhatsAppList = () => ({
  type: WHATSAPP_GET_LIST,
});

export const getWhatsAppListSuccess = (whatsApps) => ({
  type: WHATSAPP_GET_LIST_SUCCESS,
  payload: whatsApps,
});

export const getWhatsAppListError = (error) => ({
  type: WHATSAPP_GET_LIST_ERROR,
  payload: error,
});

export const updateWhatsAppItem = (whatsApp) => ({
  type: WHATSAPP_UPDATE_ITEM,
  payload: whatsApp,
});

export const updateWhatsAppSession = (session) => ({
  type: WHATSAPP_UPDATE_SESSION,
  payload: session,
});

export const deleteWhatsAppItem = (whatsAppId) => ({
  type: WHATSAPP_DELETE_ITEM,
  payload: whatsAppId,
});

export const addWhatsAppItem = (whatsApp) => ({
  type: WHATSAPP_ADD_ITEM,
  payload: whatsApp,
});

export const resetWhatsAppList = () => ({
  type: WHATSAPP_RESET_LIST,
});
